import { IActivationComment } from "@/models";
import { BaseRepository } from "@/repositories/BaseRepository";

class ActivationCommentRepository extends BaseRepository<IActivationComment> {
    constructor() {
        super("/Activations");
    }

    public getComments(ativationId: number): Promise<IActivationComment[]> {
        const path = `${ativationId}/comments`;
        return this.getAll({}, path);
    }

    public addComment(ativationId: number, payload): Promise<IActivationComment> {
        const path = `${ativationId}/comments`;
        return this.post(path, payload);
    }
}

const activationCommentRepository = new ActivationCommentRepository();
export { ActivationCommentRepository, activationCommentRepository };
